import { create } from 'zustand';
import { getObjectsApi } from '../api/api';

export const useObjectsStore = create((set, get) => ({
  objects: [],
  objectsExist: false,
  loading: false,

  setLoading: (loading) => set({ loading }),
  setObjects: (objects) =>
    set(() => ({
      objects,
      objectsExist: objects.length > 0,
    })),

  getObjects: async () => {
    set({ loading: true });
    await getObjectsApi(
      (data) => {
        set(() => ({
          objects: data,
          objectsExist: data.length > 0,
          loading: false,
        }));
      },
      () =>
        set(() => ({
          loading: false,
        }))
    );
  },
}));
